/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Dropdown, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _, { get } from 'lodash';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  URASoruceHead,
  URACalcHead,
  URAPaymentHead,
  InterestCalcHead,
  FederalFamilyHead,
  FederalPercentHead,
} from './tablehead';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../SharedModules/utilities/utilities';
import {
  closeTab,
  redirectURLLink,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';

import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import * as Messages from './RebatePgmConstants';
import {
  getCheckPay,
  getClaimCodeList,
  getDropdownByCode,
  getQtrAndUnitType,
} from './store/actions';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import { FormControl, FormHelperText, Input } from '@material-ui/core';

const DetailsTab = (props) => {
  const dispatch = useDispatch();
  const {
    changeHandler,
    blurHandler,
    flderr,
    details,
    callFrom,
    isEnablebyRole,
  } = props;
  const [check_pay, setCheckPay] = React.useState([]);
  const [rebate_unit_type, setRebateUnit] = React.useState([]);
  const [dispute_code, setDisputeCode] = React.useState([]);
  const [drug_type_src, setDrugType] = React.useState([]);
  const [claim_code, setClaimCode] = React.useState([]);
  const [day_count, setDayCount] = React.useState([]);
  const [adjustment_qtr, setAdjustQtr] = React.useState([]);
  const [state_cd, setStateCd] = React.useState([]);

  // const check_pay = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.check_pay
  // );
  // const state_cd = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.state_cd
  // );
  // const claim_code = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.claim_code
  // );
  // const adjustment_qtr = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.adjustment_qtr
  // );
  // const day_count = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.day_count
  // );
  // const drug_type_src = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.drug_type_src
  // );
  // const dispute_code = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.dispute_code
  // );
  const unit_type = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.unit_type
  );
  // const rebate_unit_type = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.rebate_unit_type
  // );

  const getDropdownData = async () => {
    let list = await dispatch(
      getDropdownByCode([
        'CHECK_PAYEE_CD',
        'STATE_CD',
        'ADJUSTMENT_QTR_CD',
        'DAY_COUNT_METHOD_CD',
        'DRUG_TYPE_SOURCE_CD',
        'ADJUSTMENT_DISPUTE_CD',
        'REBATE_UNIT_TYPE_CD',
      ])
    );
    setCheckPay(list?.CHECK_PAYEE_CD ? list.CHECK_PAYEE_CD : []);
    setStateCd(list?.STATE_CD ? list.STATE_CD : []);
    setAdjustQtr(list?.ADJUSTMENT_QTR_CD ? list.ADJUSTMENT_QTR_CD : []);
    setDayCount(list?.DAY_COUNT_METHOD_CD ? list.DAY_COUNT_METHOD_CD : []);
    setDrugType(list?.DRUG_TYPE_SOURCE_CD ? list.DRUG_TYPE_SOURCE_CD : []);
    setDisputeCode(
      list?.ADJUSTMENT_DISPUTE_CD ? list.ADJUSTMENT_DISPUTE_CD : []
    );
    setRebateUnit(list?.REBATE_UNIT_TYPE_CD ? list.REBATE_UNIT_TYPE_CD : []);
    list = await dispatch(getClaimCodeList());
    setClaimCode(list);
  };

  React.useEffect(() => {
    // if (!check_pay) dispatch(getCheckPay('CHECK_PAYEE_CD'));
    // if (!state_cd) dispatch(getCheckPay('STATE_CD'));
    // if (!adjustment_qtr) dispatch(getCheckPay('ADJUSTMENT_QTR_CD'));
    // if (!day_count) dispatch(getCheckPay('DAY_COUNT_METHOD_CD'));
    // if (!claim_code) dispatch(getClaimCodeList());
    // if (!drug_type_src) dispatch(getCheckPay('DRUG_TYPE_SOURCE_CD'));
    // if (!dispute_code) dispatch(getCheckPay('ADJUSTMENT_DISPUTE_CD'));
    if (!unit_type) dispatch(getCheckPay('UNIT_TYPE_CD'));
    // if (!rebate_unit_type) dispatch(getCheckPay('REBATE_UNIT_TYPE_CD'));
    getDropdownData();
  }, []);

  // React.useEffect(() => {
  //   const adjustQtr = details?.planTypeCd === 'FD' ? 'P' : '';
  //   changeHandler(adjustQtr, 'adjustmentQtrCd');
  // }, [adjustment_qtr]);

  React.useEffect(() => {
    const hiddenTextarea = document.querySelector(
      'textarea[aria-hidden="true"]'
    );

    // Check if the hidden textarea exists
    if (hiddenTextarea) {
      // Assign an ID to the hidden textarea
      hiddenTextarea.setAttribute('id', 'hiddenTextArea');

      // Optionally, you can add an aria-labelledby to link it with a label
      // hiddenTextarea.setAttribute('aria-labelledby', 'hiddenLabel');
    }
  }, []);
  return (
    <div data-testid='detailsTab' className='details-tab'>
      <fieldset
        className='custom-fieldset frr-remove-custom-field-margin'
        style={{ height: 'auto' }}
      >
        <div className='form-wrapper'>
          <div className='mui-custom-form frr-mui-custom-form-new col-sm-5 col-xl-4 mx-xl-0'>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='descsrt'
                label='Short Description'
                required
                data-testid='shortDescrpt'
                value={details?.shortDescr || ''}
                inputProps={{ maxLength: 30, id: 'descsrt' }}
                onChange={(e) => changeHandler(e.target.value, 'shortDescr')}
                onBlur={(e) => blurHandler(e.target.value, 'shortDescr')}
                InputLabelProps={{ shrink: true }}
                helperText={flderr?.shtDescErr ? Messages.SHORT_DESC_ERR : null}
                error={flderr?.shtDescErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='checkpay'
                data-testid='checkPayee'
                label='Check Payee'
                required
                select
                InputLabelProps={{ shrink: true }}
                inputProps={{ id: 'checkpay' }}
                value={details?.checkPayeeCd || '-1'}
                onChange={(e) => changeHandler(e.target.value, 'checkPayeeCd')}
                onBlur={(e) => blurHandler(e.target.value, 'checkPayeeCd')}
                helperText={flderr?.checkPayErr ? Messages.CHECK_PAY_ERR : null}
                error={flderr?.checkPayErr}
                disabled={!isEnablebyRole}
              >
                <MenuItem
                  key=''
                  value='-1'
                  className='frr-dropdown-blank-item'
                />
                {check_pay &&
                  check_pay.map((item, ind) => (
                    <MenuItem key={ind} value={item.codeValueID.codeValue}>
                      {item.codeValueID.codeValue}: {item.shortDescription}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            {details?.planTypeCd !== 'SUPP' ? (
              <TextField
                className='mb-3'
                id='rebatepgmcode'
                data-testid='rebatepgmcode'
                label='Claim Rebate Program Code'
                InputLabelProps={{ shrink: true }}
                inputProps={{ id: 'rebatepgmcode' }}
                value={details?.claimRebateProgramCd || ''}
                InputProps={{ readOnly: true }}
                disabled={  details?.planTypeCd === 'SUPP' ? false : true || !isEnablebyRole}
              />
            ) : (
              <TextField
                className='mb-3'
                id='rebatepgmcode'
                data-testid='rebatepgmcode'
                label='Claim Rebate Program Code'
                select
                InputLabelProps={{ shrink: true }}
                inputProps={{ id: 'rebatepgmcode' }}
                value={details?.claimRebateProgramCd || ''}
                onChange={(e) => {
                  changeHandler(e.target.value, 'claimRebateProgramCd');
                  dispatch(
                    getQtrAndUnitType(
                      { claimRebateProgramCd: e.target.value },
                      details,
                      callFrom
                    )
                  );
                }}
                onBlur={(e) =>
                  blurHandler(
                    e.target.value,
                    'claimRebateProgramCd',
                    details?.planTypeCd
                  )
                }
                helperText={
                  flderr?.claimRebateProgramCdReqErr
                    ? Messages.CLAIM_REBATE_PGM_REQ_ERR
                    : null
                }
                error={flderr?.claimRebateProgramCdReqErr}
                required={details?.planTypeCd === 'SUPP'}
                disabled={
                  isEnablebyRole? (details?.planTypeCd === 'SUPP' ? false : true) : true
                }
              >
                <MenuItem className='frr-dropdown-blank-item' key='' value='-1' />
                {claim_code &&
                  claim_code.map((item, ind) => (
                    <MenuItem key={ind} value={item.claimRebateProgramCd}>
                      {item.claimRebateProgramCd}: {item.shortDescr}
                    </MenuItem>
                  ))}
              </TextField>
            )}
            <FormControlLabel
              className='ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Switch Out of Sequence Order of ROSI/PQAS'
              value={details?.switchRosiPqasInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'switchRosiPqasInd', true)
              }
              checked={details?.switchRosiPqasInd === 1}
              data-testid='rosi_pqas'
              disabled={!isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='MCO Report'
              value={details?.mcoRptInd === 1}
              onChange={(e, val) => changeHandler(val, 'mcoRptInd', true)}
              checked={details?.mcoRptInd === 1}
              data-testid='mco_report'
              disabled={!isEnablebyRole}
            />
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='fiscal'
                label='Fiscal Year Begin Month/Day'
                required
                data-testid='fiscalYear'
                InputProps={{ id: 'fiscal' }}
                InputLabelProps={{ shrink: true }}
                value={details?.fiscalYearBeginDt || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'fiscalYearBeginDt')
                }
                onBlur={(e) => blurHandler(e.target.value, 'fiscalYearBeginDt')}
                helperText={
                  flderr?.fiscalYrReqErr
                    ? Messages.FISCAL_YR_REQ_ERR
                    : flderr?.fiscalYrErr
                    ? Messages.FISCAL_YR_ERR
                    : null
                }
                error={flderr?.fiscalYrReqErr || flderr?.fiscalYrErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='summaryrpt'
                data-testid='summaryrpt'
                label='First Summary Report Quarter'
                // required
                inputProps={{maxLength:6}}
                InputProps={{ id: 'summaryrpt' }}
                InputLabelProps={{ shrink: true }}
                value={details?.firstSummaryRptQtr || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'firstSummaryRptQtr')
                }
                onBlur={(e) =>
                  blurHandler(e.target.value, 'firstSummaryRptQtr')
                }
                helperText={
                  // flderr?.firstSummaryRptQtrReqErr
                  //   ? Messages.FIRST_SUMMARY_QTR_REQ_ERR
                  //   :
                  flderr?.firstSummaryRptQtrErr
                    ? constantMessageData.VALIDATE_QUARTER_VALUE
                    : null
                }
                error={
                  // flderr?.firstSummaryRptQtrReqErr ||
                  flderr?.firstSummaryRptQtrErr
                }
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='forgive'
                data-testid='forgive'
                label='Forgive/Write-Off Threshold'
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 12, id: 'forgive' }}
                value={
                  details?.frgvWoffThreshold === null
                    ? 0
                    : details?.frgvWoffThreshold
                }
                onChange={(e) => {
                  // const val = parseFloat(e.target.value, 10);
                  changeHandler(e.target.value, 'frgvWoffThreshold');
                }}
                onBlur={(e) => blurHandler(e.target.value, 'frgvWoffThreshold')}
                helperText={
                  flderr?.frgvWoffThresholdErr
                    ? Messages.FORGIVE_THRESHOLD_NUM_ERR
                    : null
                }
                error={flderr?.frgvWoffThresholdErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='drugtype'
                select
                data-testid='drugtype'
                label='Drug Type Source'
                InputLabelProps={{ shrink: true }}
                inputProps={{ id: 'drugtype' }}
                value={details?.drugTypeSourceCd || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'drugTypeSourceCd')
                }
                onBlur={(e) => blurHandler(e.target.value, 'drugTypeSourceCd')}
                required
                helperText={
                  flderr?.drugTypeSourceCdReqErr
                    ? Messages.DRUG_TYPE_REQ_ERR
                    : null
                }
                error={flderr?.drugTypeSourceCdReqErr}
                disabled={!isEnablebyRole}
              >
                <MenuItem
                  key=''
                  className='frr-dropdown-blank-item'
                  value='-1'
                />
                {drug_type_src &&
                  drug_type_src.map((item, ind) => (
                    <MenuItem key={ind} value={item.codeValueID.codeValue}>
                      {item.codeValueID.codeValue}: {item.shortDescription}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='noofmanu'
                data-testid='noofmanu'
                label='Number of Debit Manufacturers'
                inputProps={{ maxLength: 4, id: 'noofmanu' }}
                InputLabelProps={{ shrink: true }}
                value={details?.numOfDebitMfg?.toString() || ''}
                onChange={(e) => changeHandler(e.target.value, 'numOfDebitMfg')}
                onBlur={(e) => blurHandler(e.target.value, 'numOfDebitMfg')}
                helperText={
                  flderr?.numOfDebitMfgErr
                    ? Messages.DEBIT_MANUFACTURERS_ERR
                    : null
                }
                error={flderr?.numOfDebitMfgErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Use MCO Service Date'
              value={details?.useMcoServiceDtInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'useMcoServiceDtInd', true)
              }
              checked={details?.useMcoServiceDtInd === 1}
              data-testid='mco_change'
              disabled={
                details?.planTypeCd === 'SUPP' || callFrom === 'maintainRebate'
              }
            />
          </div>
          <div className='mui-custom-form frr-mui-custom-form-new frr-custom-textarea col-sm-5 col-xl-4 mx-xl-0'>
            <div className='input-md mandate-fields frr-required-red-astricon'>
              <label className='hide-elm' htmlFor='hiddenTextArea'>
                Long Description
              </label>
              <legend className=' legend-font mb-1 ml-0' htmlFor='longdescrp'>
                Long Description
              </legend>
              <TextField
                className='mb-3 fieldset-customization custom-textarea'
                id='longdescrp'
                data-testid='longdescrp'
                label='Long Description'
                required
                inputProps={{ maxLength: 255, id: 'longdescrp' }}
                aria-label='Long Description'
                multiline
                rows={2}
                rowsMax={14}
                onChange={(e) => changeHandler(e.target.value, 'longDescr')}
                onBlur={(e) => blurHandler(e.target.value, 'longDescr')}
                InputLabelProps={{ shrink: false }}
                value={details?.longDescr || ''}
                helperText={flderr?.longDescErr ? Messages.LONG_DESC_ERR : null}
                error={flderr?.longDescErr}
                disabled={!isEnablebyRole}
              />
            </div>

            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Add With New Federal'
              value={details?.addWithNewFedInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'addWithNewFedInd', true)
              }
              checked={details?.addWithNewFedInd === 1}
              data-testid='new_federal'
              disabled={
                callFrom === 'createRebate' && details?.planTypeCd === 'ST'
                  ? false
                  : true || !isEnablebyRole
              }
            />
            <FormControlLabel
              className='ml-0 checkBoxCustomMargin  frr-custom-font-12m600 db '
              control={<Checkbox color='primary' />}
              label='Allow Price Entry'
              value={details?.allowPriceEntryInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'allowPriceEntryInd', true)
              }
              checked={details?.allowPriceEntryInd === 1}
              data-testid='allowPrice'
              disabled={!isEnablebyRole}
            />
            <FormControlLabel
              className='ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Use Member Number in Patient ID'
              value={details?.useMemberNumberInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'useMemberNumberInd', true)
              }
              checked={details?.useMemberNumberInd === 1}
              data-testid='member_no'
              disabled={!isEnablebyRole}
            />
            <div className='input-md mandate-fields frr-custom-margin-0'>
              <TextField
                className='mb-3 pt-1 frr-custom-margin-top frr-mt-35 '
                id='lastqtr'
                data-testid='lastqtr'
                label='Last Quarter Without Claims'
                inputProps={{maxLength:6}}
                required
                InputProps={{ id: 'lastqtr'}}
                InputLabelProps={{ shrink: true }}
                value={details?.lastQtrWithoutClaims || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'lastQtrWithoutClaims')
                }
                onBlur={(e) =>
                  blurHandler(e.target.value, 'lastQtrWithoutClaims')
                }
                helperText={
                  flderr?.lastQtrWithoutClaimsReqErr
                    ? Messages.LAST_QTR_REQ_ERR
                    : flderr?.lastQtrWithoutClaimsErr
                    ? constantMessageData.VALIDATE_QUARTER_VALUE
                    : null
                }
                error={
                  flderr?.lastQtrWithoutClaimsReqErr ||
                  flderr?.lastQtrWithoutClaimsErr
                }
                disabled={!isEnablebyRole}
              />
            </div>
            <TextField
              className='mb-3'
              id='adjustqtr'
              data-testid='adjustqtr'
              label='Adjustment Quarter'
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ id: 'adjustqtr' }}
              value={details?.adjustmentQtrCd || '-1'}
              onChange={(e) => changeHandler(e.target.value, 'adjustmentQtrCd')}
              disabled={
                details?.planTypeCd === 'FD' ? true : false || !isEnablebyRole
              }
            >
              <MenuItem className='frr-dropdown-blank-item' key='' value='-1' />
              {adjustment_qtr &&
                adjustment_qtr.map((item, ind) => (
                  <MenuItem key={ind} value={item.codeValueID.codeValue}>
                    {item.codeValueID.codeValue}: {item.shortDescription}
                  </MenuItem>
                ))}
            </TextField>
            <div className='input-md mandate-fields frr-text-feild-wrap'>
              <TextField
                className='mb-3 frr-label-width-350'
                id='threshold'
                data-testid='threshold'
                required
                label='Declare Balanced/Modified Units Threshold'
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 12, id: 'threshold' }}
                value={
                  details?.dbalModThreshold === null
                    ? 0
                    : details?.dbalModThreshold
                }
                onChange={(e) =>
                  changeHandler(e.target.value, 'dbalModThreshold')
                }
                onBlur={(e) => blurHandler(e.target.value, 'dbalModThreshold')}
                helperText={
                  flderr?.dbalModThresholdReqErr
                    ? Messages.DEC_THRES_REQ_ERR
                    : flderr?.dbalModThresholdErr
                    ? Messages.DEC_THRES_ERR
                    : null
                }
                error={
                  flderr?.dbalModThresholdErr || flderr?.dbalModThresholdReqErr
                }
                disabled={!isEnablebyRole}
              />
            </div>
            <TextField
              className='mb-3'
              id='disputecode'
              data-testid='disputecode'
              select
              label='Default Dispute Resolved Code'
              InputLabelProps={{ shrink: true }}
              inputProps={{ id: 'disputecode' }}
              value={details?.disputeResolvedCd || ''}
              onChange={(e) =>
                changeHandler(e.target.value, 'disputeResolvedCd')
              }
              disabled={!isEnablebyRole}
            >
              <MenuItem className='frr-dropdown-blank-item' key='' value='-1' />
              {dispute_code &&
                dispute_code.map((item, ind) => (
                  <MenuItem key={ind} value={item.codeValueID.codeValue}>
                    {item.codeValueID.codeValue}: {item.shortDescription}
                  </MenuItem>
                ))}
            </TextField>
            <TextField
              className='mb-3'
              id='typecode'
              data-testid='typecode'
              select
              label='Rebate Unit Type Code'
              inputProps={{ id: 'typecode' }}
              InputLabelProps={{ shrink: true }}
              value={details?.rebateUnitTypeCd || ''}
              onChange={(e) =>
                changeHandler(e.target.value, 'rebateUnitTypeCd')
              }
              disabled={
                details?.planTypeCd === 'ST' ||
                details?.planTypeCd === 'SUPP' ||
                details?.planTypeCd === 'COMM' ||
                !isEnablebyRole
              }
            >
              <MenuItem className='frr-dropdown-blank-item' key='' value='-1' />
              {rebate_unit_type &&
                rebate_unit_type.map((item, ind) => (
                  <MenuItem key={ind} value={item.codeValueID.codeValue}>
                    {item.codeValueID.codeValue}: {item.shortDescription}
                  </MenuItem>
                ))}
            </TextField>

            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Allow Coverage Gap'
              value={details?.allowCvgGapInd === 1}
              onChange={(e, val) => changeHandler(val, 'allowCvgGapInd', true)}
              checked={details?.allowCvgGapInd === 1}
              data-testid='allowCoverage'
              disabled={!(details?.planTypeCd === 'ST') || !isEnablebyRole}
            />
          </div>
          <div className='mui-custom-form frr-mui-custom-form-new col-sm-6 col-xl-4 mx-xl-0'>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='state'
                label='State'
                data-testid='State'
                required={details?.planTypeCd !== 'COMM'}
                select
                InputLabelProps={{ shrink: true }}
                inputProps={{ id: 'state' }}
                value={details?.stateAbbrev || ''}
                onChange={(e) => changeHandler(e.target.value, 'stateAbbrev')}
                onBlur={(e) =>
                  blurHandler(
                    e.target.value,
                    'stateAbbrev',
                    details?.planTypeCd
                  )
                }
                helperText={flderr?.stateErr ? Messages.STATE_ERR : null}
                error={flderr?.stateErr}
                disabled={!isEnablebyRole}
              >
                <MenuItem
                  className='frr-dropdown-blank-item'
                  key=''
                  value='-1'
                />
                {state_cd &&
                  state_cd.map((item, ind) => (
                    <MenuItem key={ind} value={item.codeValueID.codeValue}>
                      {item.codeValueID.codeValue}: {item.shortDescription}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='cms64'
                data-testid='cms64'
                label='CMS 64 Agency'
                required={details?.planTypeCd === 'FD'}
                inputProps={{ id: 'cms64', maxLength: 50 }}
                InputLabelProps={{ shrink: true }}
                value={details?.cms64AgencyName || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'cms64AgencyName')
                }
                onBlur={(e) =>
                  blurHandler(
                    e.target.value,
                    'cms64AgencyName',
                    details?.planTypeCd
                  )
                }
                helperText={flderr?.cms64Err ? Messages.CMS64_ERR : null}
                error={flderr?.cms64Err}
                disabled={!isEnablebyRole}
              />
            </div>
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Default Use Federal Invoice Contact'
              value={details?.defUseFedInvContactInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'defUseFedInvContactInd', true)
              }
              checked={details?.defUseFedInvContactInd === 1}
              data-testid='federal_invoice'
              disabled={
                details?.planTypeCd === 'ST' && details?.addWithNewFedInd === 1
                  ? false
                  : true || !isEnablebyRole
              }
            />
            <FormControlLabel
              className='ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Allow Price Entry With CMS URA Present'
              value={details?.allowEntryWithCmsUraInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'allowEntryWithCmsUraInd', true)
              }
              checked={details?.allowEntryWithCmsUraInd === 1}
              data-testid='price_enty'
              disabled={details?.allowPriceEntryInd !== 1 || !isEnablebyRole}
            />
            <FormControlLabel
              className='ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Units use Ratio of Reimbursed Amount'
              value={details?.unitsUseReimbRatioInd === 1}
              onChange={(e, val) =>
                changeHandler(val, 'unitsUseReimbRatioInd', true)
              }
              checked={details?.unitsUseReimbRatioInd === 1}
              data-testid='units'
              disabled={!isEnablebyRole}
            />
            <div className='input-md mandate-fields frr-custom-margin-Drams mt-3 pt-1'>
              <TextField
                className='mb-3 pt-1'
                id='startqtr'
                data-testid='startqtr'
                inputProps={{maxLength:6}}
                label='Drams Invoice Start Quarter'
                // required
                InputProps={{ id: 'startqtr' }}
                InputLabelProps={{ shrink: true }}
                value={details?.dramsInvoiceStartQtr || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'dramsInvoiceStartQtr')
                }
                onBlur={(e) =>
                  blurHandler(e.target.value, 'dramsInvoiceStartQtr')
                }
                helperText={
                  flderr?.dramsInvoiceStartQtrErr
                    ? constantMessageData.VALIDATE_QUARTER_VALUE
                    : null
                }
                error={flderr?.dramsInvoiceStartQtrErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='rptthreshold'
                data-testid='rptthreshold'
                required
                label='Report Balance Due Threshold'
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 12, id: 'rptthreshold' }}
                value={details?.rptBalanceDueThreshold}
                onChange={(e) =>
                  changeHandler(e.target.value, 'rptBalanceDueThreshold')
                }
                onBlur={(e) =>
                  blurHandler(e.target.value, 'rptBalanceDueThreshold')
                }
                helperText={
                  flderr?.rptBalanceDueThresholdReqErr
                    ? Messages.REPORT_BALANCE_DUE_REQ_ERR
                    : flderr?.rptBalanceDueThresholdErr
                    ? Messages.REPORT_BALANCE_DUE_ERR
                    : null
                }
                error={
                  flderr?.rptBalanceDueThresholdErr ||
                  flderr?.rptBalanceDueThresholdReqErr
                }
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='dayletters'
                label='Day Counting Method For Letters'
                required
                select
                data-testid='dayletters'
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 9, id: 'dayletters' }}
                value={details?.dayCountMethodCd || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'dayCountMethodCd')
                }
                onBlur={(e) => blurHandler(e.target.value, 'dayCountMethodCd')}
                helperText={
                  flderr?.dayCountReqErr ? Messages.DAY_COUNT_REQ_ERR : null
                }
                error={flderr?.dayCountReqErr}
                disabled={!isEnablebyRole}
              >
                <MenuItem
                  className='frr-dropdown-blank-item'
                  key=''
                  value='-1'
                />
                {day_count &&
                  day_count.map((item, ind) => (
                    <MenuItem key={ind} value={item.codeValueID.codeValue}>
                      {item.codeValueID.codeValue}: {item.shortDescription}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='creditmanu'
                data-testid='creditmanu'
                label='Number of Credit Manufacturers'
                inputProps={{ maxLength: 4, id: 'creditmanu' }}
                InputLabelProps={{ shrink: true }}
                value={details?.numOfCreditMfg?.toString() || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'numOfCreditMfg')
                }
                onBlur={(e) => blurHandler(e.target.value, 'numOfCreditMfg')}
                helperText={
                  flderr?.numOfCreditMfgErr
                    ? Messages.CREDIT_MANUFACTURERS_ERR
                    : null
                }
                error={flderr?.numOfCreditMfgErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <FormControlLabel
              className='mt-3 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Include Disputes Prior to DRAMS Start Quarter in Assignment Process'
              value={details?.assignDisputePriorDramsInd === 1}
              onChange={(e, val) => {
                changeHandler(val, 'assignDisputePriorDramsInd', true);
              }}
              checked={details?.assignDisputePriorDramsInd === 1}
              data-testid='dramschk'
              disabled={!isEnablebyRole}
            />
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default DetailsTab;
